import * as z from "zod";

export const setForceResyncOnGroups = {
  name: "setForceResyncOnGroups" as const,
  input: z.object({ groupIds: z.array(z.string()) }),
  output: z.object({ success: z.boolean(), updatedCount: z.number() }),
};
